var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Announcement-Edit" },
    [
      _c("TabelToolBar", {
        on: {
          onSave_OuterBoxLabelManagement: _vm.onSave_OuterBoxLabelManagement,
          AddNotice: _vm.AddNotice
        }
      }),
      _c("EditTable", { ref: "EditTable" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }